module.exports = __webpack_public_path__ + "assets/img/svg/language.svg";